import axios from "axios";

interface HomePageMentorPanel {
  _id: string;
  org: string;
  subject: string;
  mentors: string[];
  title: string;
  subtitle: string;
  panelUrl: string;
}

export interface HomePageMentor {
  _id: string;
  name: string;
  title: string;
  keywords: string[];
  transcript: string;
  mentorUrl: string;
  thumbnail: string;
}

export interface HomePageData {
  panels: HomePageMentorPanel[];
  mentors: HomePageMentor[];
  activeMentorIds: string[];
}

interface GraphQLError {
  message: string;
}

interface HomePageDataQueryResponse {
  data?: {
    homePageData: HomePageData;
  };
  errors?: GraphQLError[];
}

//OLD
/*
const homePageDataQuery = `
query HomePageData($orgId: String) {
        homePageData(orgId: $orgId) {
          mentors {
            _id
            name
            title
            keywords
            transcript
            mentorUrl
            thumbnail
          }
          panels {
            _id
            org
            subject
            mentors
            title
            subtitle
            panelUrl
          }
        }
      }
`;
*/
//NEW
const homePageDataQuery = `
query HomePageData($orgId: String) {
        homePageData(orgId: $orgId) {
          mentors {
            _id
            name
            title
            keywords
            transcript
            mentorUrl
            thumbnail
          }
          panels {
            _id
            org
            subject
            mentors
            title
            subtitle
            panelUrl
          }
          activeMentorIds
        }
      }
`;

export async function fetchHomePageData(
  orgId = import.meta.env.VITE_PATHWAYS_ORG_ID,
): Promise<HomePageData> {
  const graphqlEndpoint = import.meta.env.VITE_GRAPHQL_ENDPOINT;
  if (!graphqlEndpoint) {
    throw new Error("GraphQL endpoint is not defined.");
  }

  const gqlRes = await axios.post<HomePageDataQueryResponse>(graphqlEndpoint, {
    query: homePageDataQuery,
    variables: {
      orgId: orgId,
    },
  });

  if (gqlRes.status !== 200) {
    throw new Error(`HomePageData load failed: ${gqlRes.statusText}}`);
  }
  if (gqlRes.data.errors) {
    throw new Error(
      `errors reponse to homePageData query: ${JSON.stringify(
        gqlRes.data.errors,
      )}`,
    );
  }
  if (!gqlRes.data.data) {
    throw new Error(
      `no data in non-error reponse: ${JSON.stringify(gqlRes.data)}`,
    );
  }
  return gqlRes.data.data.homePageData;
}
